module.exports = __webpack_public_path__ + "img/img-isfj.70d94785.jpg";